import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { getSelectedResources } from '../utils/exportHelpers'
import ExportChoiceCards from './ExportChoiceCards'

const EXPORT_ALL_DESCRIPTION =
  'Exportez toutes les données disponibles pour obtenir un aperçu complet de votre collecte.'
const CUSTOMIZE_DESCRIPTION =
  'Configurez un export ciblé en choisissant les variables et sections qui vous intéressent.'

const ExcelOptions = ({ onExport, collect, draft, selectionParam, ignoreFilters }) => {
  const handleCustomize = useCallback(() => {
    const selectedResources = getSelectedResources()
    const params = new URLSearchParams()

    if (selectedResources.resourceIds?.length > 0)
      params.set(selectionParam, selectedResources.resourceIds.join(','))
    if (selectedResources.allResources)
      params.set('all_resources', 'true')
    if (selectedResources.query && !ignoreFilters)
      params.set('q', selectedResources.query)
    if (selectedResources.resourceStatus)
      params.set('resource_status', selectedResources.resourceStatus)
    if (selectedResources.startDate)
      params.set('start_date', selectedResources.startDate)
    if (selectedResources.endDate)
      params.set('end_date', selectedResources.endDate)

    const queryString = params.toString()
    const exportPath = draft?.id ? `/drafts/${draft.id}/resources_exports` : '/resources_exports'
    const baseUrl = `/collects/${collect.id}${exportPath}`
    window.location.href = queryString ? `${baseUrl}?${queryString}` : baseUrl
  }, [collect.id, draft?.id, selectionParam, ignoreFilters])

  const handleExportClick = useCallback(() => {
    onExport()
  }, [onExport])

  return (
    <ExportChoiceCards
      exportAllTitle="Tout exporter"
      exportAllDescription={EXPORT_ALL_DESCRIPTION}
      customizeDescription={CUSTOMIZE_DESCRIPTION}
      onExportAll={handleExportClick}
      onCustomize={handleCustomize}
    />
  )
}

ExcelOptions.propTypes = {
  collect: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired,
  draft: PropTypes.shape({
    id: PropTypes.number.isRequired
  }),
  ignoreFilters: PropTypes.bool,
  onExport: PropTypes.func.isRequired,
  selectionParam: PropTypes.string
}

ExcelOptions.defaultProps = {
  draft: null,
  ignoreFilters: false,
  selectionParam: 'resource_ids'
}

export default ExcelOptions
